import genVersion from './version';

export const version = genVersion;
export const name = 'Virbac no Campo';
export const frApiToken: string = process.env.REACT_APP_API_TOKEN!;
export const frBaseUrl = process.env.REACT_APP_FAZENDA_RENTAVEL_URL;

// todos os campos do firebaseConfig são obrigatórios (checados em scripts/check-required-env.js,
// que roda antes do build/start) — sem fallback hardcoded de propósito: um build sem essas vars deve
// falhar alto, não cair silenciosamente apontando pro projeto de produção.
export const frWebApiToken: string = process.env.REACT_APP_FIREBASE_WEB_APIKEY!;
export const fbAuthDomain: string = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!;
export const fbProjectId: string = process.env.REACT_APP_FIREBASE_PROJECT_ID!;
export const fbStorageBucket: string = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!;
export const fbMessagingSenderId: string = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID!;
export const fbAppId: string = process.env.REACT_APP_FIREBASE_APP_ID!;
export const fbMeasurementId: string = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID!;

export const googleRecaptchaSiteKey: string = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY!;
export const debugMode: boolean = process.env.REACT_APP_DEBUG === 'true';

function toNumber(arg: any, defaultVal: number): number {
  if (arg)
    return Number.parseInt(arg);
  return defaultVal;
}

// Firebase emulator
export const fbUseEmulator: boolean = process.env.REACT_APP_USE_EMULATOR === 'true';
export const fbEmulatorHost: string = process.env.REACT_APP_EMULATOR_HOST || 'localhost';
export const fbEmulatorPort: number = toNumber(process.env.REACT_APP_EMULATOR_PORT, 8080);
export const fbEmulatorAuthHost: string = process.env.REACT_APP_EMULATOR_AUTH_HOST || 'localhost';
export const fbEmulatorAuthPort: number = toNumber(process.env.REACT_APP_EMULATOR_AUTH_PORT, 9099);
export const fbEmulatorStorageHost: string = process.env.REACT_APP_EMULATOR_STORAGE_HOST || 'localhost';
export const fbEmulatorStoragePort: number = toNumber(process.env.REACT_APP_EMULATOR_STORAGE_PORT, 9199);


export function debug(name:string, args?:any): void {
  if (debugMode)
    console.log(name, args);
}

// Variaveis aplicacao
export const agendaDefaultProximosDias = 5;
export const agendaDefaultDias = 30;
export const agendaLimiteDias = 365;
export const maxUploadSize = 32 * 1024 * 1024;

// vars DEBUG
export const acervoOldUploadMode: boolean = process.env.REACT_APP_ACERVO_OLD_UPLOAD_MODE === 'true';